import {Component} from '@angular/core';

import {ParametersService} from "../core";

@Component({
    selector: 'home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent {
    constructor(public parameters: ParametersService) {
    }

}
